<template>
  <div class="home">
    <div class="text-center">
      <img src="../assets/img/logo.png">
      <h1>Welcome to Shadowtools!</h1>
      <p class="lead">
        Click on the navigation links above to access the tools.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// Home.vue?86c61d06